/* Global base styles are imported from globals.css */
body {
  margin: 0;
}
